import styled from 'styled-components'

export const CustomToastStyles = styled.div``
